import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqColaborador = {
	login: async function (data) {
		return apiServer
			.post(`portal/v2/colaborador/login-portal`, data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	logout: async function () {
		return apiServer
			.post(`portal/v2/colaborador/logout`, null, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listPaginate: async function (param, paramValue, active, page, perpage = 15) {
		return apiServer
			.get("portal/v1/colaborador", {
				params: {
					param,
					paramValue,
					active,
					page,
					perpage,
				},
				headers: {
					banco: banco,
					page,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listID: async function (id) {
		return apiServer
			.get(`portal/v1/colaborador/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (data) {
		return apiServer
			.post("portal/v2/colaborador/permissions", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	patchPassword: async function (data) {
		return apiServer
			.patch(`portal/v1/colaborador/password`, data, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	// insert: async function (data) {
	// 	return apiServer
	// 		.post("portal/v1/colaborador", data, {
	// 			headers: {
	// 				banco,
	// 			},
	// 		})
	// 		.then((response) => {
	// 			return response;
	// 		})
	// 		.catch((error) => {
	// 			throw error;
	// 		});
	// },
};

export default reqColaborador;
